const REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

const ANN = [
  (document.getElementById('announce') || {}).innerHTML || 'THE PATRIOT RATE ★ 20% OFF + FREE GIFTS &amp; FREE SHIPPING'
].concat(Array.isArray((window.theme || {}).annExtra) ? window.theme.annExtra : [
  '🇺🇸 HANDCRAFTED IN THE USA · COLD-PRESSED IN SMALL BATCHES',
  '30-DAY MONEY-BACK GUARANTEE ON EVERY ORDER'
]);
let annI = 0;
(function(){
  const el = document.getElementById('announce');
  if(!el) return;
  const small = window.matchMedia('(max-width: 749px)');
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  const SPEED = 45;
  let mode = '', timer = null, resume = null, rz = null, lastW = 0;
  function seq(hide){
    return '<span class="ann-seq"' + (hide ? ' aria-hidden="true"' : '') + '>' + ANN.map(function(m){
      return '<span class="ann-msg">' + m + '</span><span class="ann-sep" aria-hidden="true">★</span>';
    }).join('') + '</span>';
  }
  function fits(){
    const pad = parseFloat(getComputedStyle(el).getPropertyValue('--ann-pad')) || 0;
    const room = el.clientWidth - pad * 2;
    const probe = document.createElement('span');
    probe.style.cssText = 'position:absolute;left:0;top:0;visibility:hidden;white-space:nowrap;pointer-events:none';
    el.appendChild(probe);
    let ok = true;
    for(let i = 0; i < ANN.length && ok; i++){
      probe.innerHTML = ANN[i];
      ok = probe.getBoundingClientRect().width <= room + 0.5;
    }
    probe.remove();
    return ok;
  }
  function apply(){
    lastW = window.innerWidth;
    let next = 'rotate';
    if(small.matches && !fits()) next = reduce.matches ? 'swipe' : 'marquee';
    if(next === mode) return;
    mode = next;
    clearInterval(timer);
    timer = null;
    clearTimeout(resume);
    el.classList.remove('ann--marquee', 'ann--swipe', 'ann--paused');
    el.scrollLeft = 0;
    if(mode === 'marquee'){
      el.innerHTML = '<span class="ann-track">' + seq(false) + seq(true) + '</span>';
      const w = el.querySelector('.ann-seq').getBoundingClientRect().width;
      el.style.setProperty('--ann-dur', Math.max(8, w / SPEED).toFixed(1) + 's');
      el.classList.add('ann--marquee');
    } else if(mode === 'swipe'){
      el.innerHTML = ANN[0];
      el.classList.add('ann--swipe');
    } else {
      annI = 0;
      el.innerHTML = ANN[0];
      if(!reduce.matches) timer = setInterval(function(){ annI = (annI + 1) % ANN.length; el.innerHTML = ANN[annI]; }, 4500);
    }
  }
  el.addEventListener('touchstart', function(){
    if(mode !== 'marquee') return;
    clearTimeout(resume);
    el.classList.add('ann--paused');
  }, { passive: true });
  ['touchend', 'touchcancel'].forEach(function(t){
    el.addEventListener(t, function(){
      if(mode !== 'marquee') return;
      clearTimeout(resume);
      resume = setTimeout(function(){ el.classList.remove('ann--paused'); }, 2500);
    }, { passive: true });
  });
  window.addEventListener('resize', function(){
    if(window.innerWidth === lastW) return;
    clearTimeout(rz);
    rz = setTimeout(apply, 150);
  });
  if(reduce.addEventListener) reduce.addEventListener('change', function(){ mode = ''; apply(); });
  apply();
})();

document.querySelectorAll('.nav-item[data-parent]').forEach(item=>{
  const link = item.querySelector('.nav-link');
  link.setAttribute('aria-expanded','false');
  link.addEventListener('click', e=>{
    const isCoarse = window.matchMedia('(pointer: coarse)').matches;
    if(isCoarse && !item.classList.contains('open')){
      e.preventDefault();
      document.querySelectorAll('.nav-item.open').forEach(o=>{ o.classList.remove('open'); o.querySelector('.nav-link').setAttribute('aria-expanded','false'); });
      item.classList.add('open');
      link.setAttribute('aria-expanded','true');
    }
  });
});
document.addEventListener('click', e=>{
  if(!e.target.closest('.nav-item[data-parent]')){
    document.querySelectorAll('.nav-item.open').forEach(o=>{ o.classList.remove('open'); o.querySelector('.nav-link').setAttribute('aria-expanded','false'); });
  }
});

let lastFocus = null;
function openMnav(){
  lastFocus = document.activeElement;
  document.getElementById('mNav').classList.add('show');
  document.getElementById('mOv').classList.add('show');
  document.getElementById('burgerBtn').setAttribute('aria-expanded','true');
  document.body.style.overflow='hidden';
  document.getElementById('mCloseBtn').focus();
  syncSticky();
}
function closeMnav(){
  document.getElementById('mNav').classList.remove('show');
  document.getElementById('mOv').classList.remove('show');
  document.getElementById('burgerBtn').setAttribute('aria-expanded','false');
  document.body.style.overflow='';
  if(lastFocus) lastFocus.focus();
  syncSticky();
}
document.addEventListener('keydown', e=>{
  if(e.key==='Escape' && document.getElementById('mNav').classList.contains('show')) closeMnav();
});
document.getElementById('mNav').addEventListener('keydown', e=>{
  if(e.key!=='Tab') return;
  const f = document.getElementById('mNav').querySelectorAll('a,button');
  const first=f[0], last=f[f.length-1];
  if(e.shiftKey && document.activeElement===first){ e.preventDefault(); last.focus(); }
  else if(!e.shiftKey && document.activeElement===last){ e.preventDefault(); first.focus(); }
});

(function(){
  const row = document.querySelector('.ugcrow');
  const dotsWrap = document.getElementById('ugcdots');
  if(!row || !dotsWrap) return;
  const cards = row.querySelectorAll('.uv');
  cards.forEach((c,i)=>{
    const b = document.createElement('button');
    b.setAttribute('aria-label','Go to video '+(i+1));
    b.addEventListener('click', ()=> c.scrollIntoView({behavior: REDUCED?'auto':'smooth', inline:'center', block:'nearest'}));
    dotsWrap.appendChild(b);
  });
  const dots = dotsWrap.querySelectorAll('button');
  function syncDots(){
    const mid = row.scrollLeft + row.clientWidth/2;
    let best=0, bd=Infinity;
    cards.forEach((c,i)=>{ const d=Math.abs(c.offsetLeft + c.offsetWidth/2 - mid); if(d<bd){bd=d;best=i;} });
    dots.forEach((d,i)=>d.classList.toggle('on', i===best));
  }
  row.addEventListener('scroll', syncDots, {passive:true});
  syncDots();
  let down=false, startX=0, startL=0;
  row.addEventListener('mousedown', e=>{ down=true; startX=e.pageX; startL=row.scrollLeft; row.classList.add('dragging'); });
  window.addEventListener('mousemove', e=>{ if(!down) return; row.scrollLeft = startL - (e.pageX - startX); });
  window.addEventListener('mouseup', ()=>{ down=false; row.classList.remove('dragging'); });
})();

(function(){
  const loop = document.getElementById('photoloop');
  if(loop) loop.innerHTML += loop.innerHTML;
})();

function syncSticky(){
  const heroCta = document.getElementById('heroCta');
  const stickybar = document.getElementById('stickybar');
  if(!heroCta || !stickybar) return;
  const drawerOpen = document.getElementById('mNav').classList.contains('show');
  const passedHero = heroCta.getBoundingClientRect().bottom < 0;
  const show = window.innerWidth <= 900 && passedHero && !drawerOpen;
  stickybar.classList.toggle('show', show);
}
window.addEventListener('scroll', syncSticky, {passive:true});
window.addEventListener('resize', syncSticky);
syncSticky();

(function(){
  var pending = null;
  document.addEventListener('click', function(e){
    var q = e.target && e.target.closest ? e.target.closest('.faq-q') : null;
    var item = q ? q.closest('.faq-item') : null;
    pending = (item && item.tagName !== 'DETAILS') ? { q: q, item: item, open: item.classList.contains('open') } : null;
  }, true);
  window.addEventListener('click', function(){
    var p = pending; pending = null;
    if(!p || p.item.classList.contains('open') !== p.open) return;
    var open = p.item.classList.toggle('open');
    p.q.setAttribute('aria-expanded', open ? 'true' : 'false');
  });
  document.querySelectorAll('.faq-item').forEach(function(item, i){
    var q = item.querySelector('.faq-q'), a = item.querySelector('.faq-a');
    if(!q || !a) return;
    if(!a.id) a.id = 'faq-a-' + i;
    if(q.tagName === 'BUTTON') q.setAttribute('type','button');
    q.setAttribute('aria-expanded', item.classList.contains('open') ? 'true' : 'false');
    q.setAttribute('aria-controls', a.id);
  });
})();

(function(){
  var main = document.getElementById('galmain'); if(!main) return;
  var thumbs = document.querySelectorAll('.gal-thumbs button');
  thumbs.forEach(function(b){
    b.addEventListener('click', function(){
      if(b.dataset.src) main.src = b.dataset.src;
      var ti = b.querySelector('img'); if(ti && ti.alt) main.alt = ti.alt;
      thumbs.forEach(function(x){ x.classList.remove('on'); });
      b.classList.add('on');
    });
  });
})();

(function(){
  var timer = null;
  function paint(n){
    document.querySelectorAll('.cart-n').forEach(function(el){ el.textContent = n < 100 ? String(n) : '99+'; });
  }
  function refresh(){
    clearTimeout(timer);
    timer = setTimeout(function(){
      fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
        .then(function(r){ return r.ok ? r.json() : null; })
        .then(function(c){ if(c && typeof c.item_count === 'number') paint(c.item_count); })
        .catch(function(){});
    }, 120);
  }
  window.rwnRefreshCartCount = refresh;
  var CART_CHANGE = /\/cart\/(add|change|update|clear)(\.js)?$/;
  if('PerformanceObserver' in window){
    try{
      new PerformanceObserver(function(list){
        list.getEntries().forEach(function(e){
          if(e.initiatorType !== 'fetch' && e.initiatorType !== 'xmlhttprequest') return;
          var path = ''; try{ path = new URL(e.name, location.href).pathname; }catch(err){ return; }
          if(CART_CHANGE.test(path)) refresh();
        });
      }).observe({ type: 'resource', buffered: false });
    }catch(err){}
  }
  ['cart:refresh', 'cart:updated', 'cart:change', 'cart:added', 'ajaxProduct:added'].forEach(function(n){
    document.addEventListener(n, refresh);
  });
  window.addEventListener('pageshow', function(e){ if(e.persisted) refresh(); });
})();
